import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { ShsManagement, ConfigurationDataReturnType, Configuration } from '@ct-shs/shs-consteed-typescript-sdk';

@Injectable()
export class ShsSdkService {
  shs: ShsManagement;
  config: ConfigurationDataReturnType;
  constructor(public store: LocalStorageService) {
    this.config = new Configuration(environment.cmsSettings.appClientId, environment.shsSettings.envName).load();
    this.shs = new ShsManagement(this.store, this.config)
  }
}